import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams ,AlertController, DateTime} from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { AuthService } from '../../providers/auth-service'
import { MODO_DESCONECTADO,NUBE_AWS,URL_SERVICIOS_LOCALESFRONT } from "../../config/url.servicio"
import { CompaniasProvider } from '../../providers/companias/companias'
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { InformesProvider } from '../../providers/informes/informes'
import * as papa from 'papaparse'
import { CajaProvider } from '../../providers/caja/caja'
import { UtilsProvider } from '../../providers/utils/utils'

@IonicPage()
@Component({
  selector: 'page-devolver-ventas',
  templateUrl: 'devolver-ventas.html',
  providers: [ AuthService ,InAppBrowser,CajaProvider]
})
export class DevolverVentasPage {
  datosPagina:any[] = []
  recorrerVal:any[]
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  fechaDesde:Date
  fechaHasta:Date
  imprimirNombreInforme:string=''
  listaVentasReimprimo = []
  parsedData:any
  parsedDataReal:any
  parseDataHeader:any

  constructor(public navCtrl: NavController, public navParams: NavParams,
             public alertControllers:AlertController,
             public storages:Storage,
             public auth: AuthService,
             public servicioCompania:CompaniasProvider,private iab: InAppBrowser,
             public servicioCaja: CajaProvider,
             public utils: UtilsProvider,
             public servicio:InformesProvider,) {
              if(!MODO_DESCONECTADO){
                this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo'])
                .then((val)=>{
                  if(val){
                    this.nombreCompaniaHeader = val['nombreCompania']
                    this.nombreCargoHeader = val['nombreCargo']
                  }
                })
                this.storages.set('reimprimirReciboCaja','')
               }else{
               
                 this.navCtrl.setRoot('PrincipalPage');
               }            
  }


  ionViewDidLoad() {
  
  }
  public event = {
    default: "ddd MMM DD YYYY HH:mm:ss"
  }

  cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }

  buscarListadoDevolverVenta(){
    let fechaDesde = this.fechaDesde
    let fechaHasta = this.fechaHasta
    this.storages.get('companiasId').then((val) => {
      
      this.servicio.buscarListadoDevolverVenta(val,fechaDesde,fechaHasta)
          .subscribe((data)=>{
           let valor = NUBE_AWS ? JSON.parse(data['_body']).data : JSON.parse(data['_body'])
           this.listaVentasReimprimo = valor
          },(error)=>{
              console.log(error)
          })

      });
  }

  reImprimirFactura(codigo:any){
    this.storages.get('companiasId').then((val) => {
        let consecutivo:number
        let deDonde: string
        let fecha: Date

        consecutivo = Number(codigo.consecutivo)
        deDonde = codigo.deDonde
        fecha = codigo.fechaVenta

    if (deDonde=='V'){
      this.servicioCaja.buscarVentasDiarias(consecutivo,val)
      .subscribe((data)=>{
        let response = NUBE_AWS ? JSON.parse(data['_body']).data[0] : data
        this.reemprimirReciboDia(response)
      },
      error=>{
        console.log(error)
      })
    }
    else
    {
      if (deDonde=='H'){
        this.servicio.buscarVentasDiariasHistorico(consecutivo,val,fecha)
        .subscribe((data)=>{
          let response = NUBE_AWS ? JSON.parse(data['_body']).data[0] : data
          this.reemprimirReciboDia(response)
        },
        error=>{
          console.log(error)
        })
      }
    }
  })
}


visualizarReciboEnPantalla(reciboCaja: any){
  this.storages.get('companiasId').then((val) => {
    let consecutivo:number
    let deDonde: string
    let fecha: Date

    consecutivo = Number(reciboCaja.consecutivo)
    deDonde = reciboCaja.deDonde
    fecha = reciboCaja.fechaVenta

if (deDonde=='V'){
  this.servicioCaja.buscarVentasDiarias(consecutivo,val)
  .subscribe((data)=>{
    this.utils.mostrarReciboDeCajaEnPantalla(consecutivo,data)
  },
  error=>{
    console.log(error)
  })
}
else
{
  if (deDonde=='H'){
    this.servicio.buscarVentasDiariasHistorico(consecutivo,val,fecha)
    .subscribe((data)=>{
      this.utils.mostrarReciboDeCajaEnPantalla(consecutivo,data)
    },
    error=>{
      console.log(error)
    })
  }
}
})

}


reemprimirReciboDia(elRecibo:any){
  let recibo = ''

      for (let index:any = 0; index < elRecibo.length; index++) {
        recibo += elRecibo[index]['reciboCaja'] + '\n'
      }

        this.servicioCaja.imprimirRecibo(recibo).subscribe(
            res => {

            },
            err => {

                    let alert = this.alertControllers.create({
                        title: '',
                        subTitle: recibo,
                        buttons: ['Cerrar']
                    });
                    alert.present();

                })
}
  
  
  mostrarMensajes(mensaje,advertencia) {
    let alert = this.alertControllers.create({
      title: advertencia,
      subTitle: mensaje,
      buttons: ['Ok']
    });
    alert.present()
  }  
  devolverFactura(codigo:any){

    this.storages.get('companiasId').then((val) => {
         let factura:number
         let deDonde:string
         factura = Number(codigo.consecutivo)
         deDonde = codigo.deDonde
         this.utils.mensajeConfirmacionDos('Factura','¿Está Seguro de devolver la factura ?','question','Si','No')
    .then((eliminarFactura: boolean) => {
     if (eliminarFactura) {
       if(deDonde === 'H') {
        this.servicioCaja.devolverVentaHistorico(val,factura,codigo.fechaVenta.substring(0,10))
        .subscribe((data)=>{
          this.utils.mensajeMuestro(`Factura`,'Devuelta Exitosamente!','success')
          this.buscarListadoDevolverVenta()
        },
         error=>{
           console.log(error)
         })
       } else {
        this.servicioCaja.devolverVenta(val,factura)
        .subscribe((data)=>{
          this.utils.mensajeMuestro(`Factura`,'Devuelta Exitosamente!','success')
          this.buscarListadoDevolverVenta()
        },
         error=>{
           console.log(error)
         })
       }
     }
     else {
       this.utils.mensajeMuestro('Factura','No se eliminó la factura','warning')
     }
   })

     })
 }
  
}




// WEBPACK FOOTER //
// ./src/pages/devolver-ventas/devolver-ventas.ts